import { toast } from 'react-toastify';

const padTo2Digits = (num) => {
    return num.toString().padStart(2, '0');
}

export const classNameInput = "text-white h-[22px] rounded w-full bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500 caret-input"
export const urlApiPlamin = process.env.REACT_APP_PLAMIN_API + '/api';

export const formatDate = (date, format = 103) => {
    let stringFormat = ''
    switch  (format) {
        case 23:
            stringFormat = [
                date.getFullYear(),                
                padTo2Digits(date.getMonth() + 1),
                padTo2Digits(date.getDate())
            ].join('-');
            break;
        case 103:
            stringFormat = [
                padTo2Digits(date.getDate()),
                padTo2Digits(date.getMonth() + 1),
                date.getFullYear()
            ].join('/');
            break;
        default:
            console.error('Ingreso un formato no valido mapeado')
    }

    return stringFormat;
}

export const formatearFechaHora = (fechaHora) => {
    if (!fechaHora) return null; 
    const [ fecha, horas ] = fechaHora.split(" ")
    const [ dia, mes, anio ] = fecha.split("/");
    const [ hora, minuto ] = horas.split(':')
    return new Date(anio, mes -1, dia, hora, minuto)
}

export const notify = (title, type, options = {}) => {
    toast[type](title, {
        position: options.position ?? "top-right",
        autoClose: options.autoClose ?? 5000,
        hideProgressBar: options.hideProgressBar ?? false,
        closeOnClick: options.closeOnClick ?? true,
        pauseOnHover: options.pauseOnHover ?? true,
        draggable: true,
        progress: undefined,
    });
}

export const soloCelular = (event, element) => {
    const key = event.keyCode ? event.keyCode : event.which
    if (key === 8) return true
    if (key > 47 && key < 58) {
        if (element.value === "") return true
        const regexp = /.[0-9]{8}$/
        if(!(regexp.test(element.value))) {
            return true
        }
    }
    event.preventDefault()
}

export const soloNumero = (event, element) => {
    const key = event.keyCode ? event.keyCode : event.which
    if (key === 8) return true
    if (key > 47 && key < 58) {
        if (element.value === "") return true
        const regexp = /.[0-9]{20}$/
        if(!(regexp.test(element.value))) {
            return true
        }
    }
    event.preventDefault()
}

export const soloDNI = (event, element) => {
    const key = event.keyCode ? event.keyCode : event.which
    if (key === 8) return true
    if (key > 47 && key < 58) {
        if (element.value === "") return true
        const regexp = /.[0-9]{7}$/
        if(!(regexp.test(element.value))) {
            return true
        }
    }
    event.preventDefault()
}

export const soloDecimal = (e, elemento) => {
    const key = e.keyCode ? e.keyCode : e.which

    if (key === 8) return true
    
    if (key > 47 && key < 58) {
        if (elemento.value === "") return true
        const regexp = /.[0-9]{9}$/

        if(!(regexp.test(elemento.value))) {
            return true
        }
    }

    if (key === 46) {
        if (elemento.value === "") return false
        const regexp = /^[0-9]+$/
        if (regexp.test(elemento.value)) {
            return true
        }
    }
    
    e.preventDefault()
}

export const formatState = (codState, nameState) => {
    let htmlrespuesta = '';
    let className = ''
    if ([2].includes(codState)) className = `cursor-pointer bg-yellow-600 px-2 py-[2px] rounded uppercase text-[11px] font-bold `
    else if ([45].includes(codState)) className = 'cursor-pointer bg-blue-600 px-2 py-[2px] rounded uppercase text-[11px] font-bold'
    else if ([7].includes(codState)) className = 'cursor-pointer bg-green-600 px-2 py-[2px] rounded uppercase text-[11px] font-bold'
    return className;
}


export const primeraLetraMayuscula = (string) => {
    var str = string;

    str = str?.toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
    });

    return str; 
}

export const todoMayuscula = (string)=> {
    var str = string;
    str = str.toUpperCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
    });
    return str;
}

export const quitarTildes = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
} 

export const generarNombreUnico = (nombrePrevio) => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${nombrePrevio}_${year}${month}${day}_${hours}${minutes}${seconds}`;
}


//--------------------------------------------- GUARDA LA IMAGEN EN EL MINIO Y LA RETORNA A DONDE SE EJECUTA LA FUNCION
export const enviarImagenMinio = async ({       
    nombreCarpeta,
    nombreArchivo,
    file
}) => {
    const url = `https://miniowebapi.abexacloud.com/api/Archivo/subirArchivo?NombreCarpeta=${nombreCarpeta}&NombreArchivo=${nombreArchivo}`
    const urlVer =`https://miniowebapi.abexacloud.com/api/Archivo/verImagen?NombreCarpeta=${nombreCarpeta}&NombreImagen=${nombreArchivo}`

    const formData = new FormData();
    const blob  = file.slice(0,file.size,'aplication/json');
    const newfile = new File([blob],file.name,{type:'aplication/json'})
    formData.append("archivo", newfile)

    try {
        const response = await fetch(url,{
            method:'POST',
            body: formData
        }).then(res => res.json())

        response.isValid ? notify('Imagen guardada correctamente','success') : notify('Ocurrio un error al guardar la imagen','error')
        return (response.isValid ? urlVer : '')
    } catch (error) {
        notify('Ocurrio un error al guardar la imagen','error')
        return ''
    }

}

export const capitalizarTexto = (texto) => {
    return texto.replace(/[-\wñáéíóú]+/g, (palabra) => {
        if (/\d/.test(palabra)) {
            return palabra.toUpperCase();
        }
        return palabra.charAt(0).toUpperCase() + palabra.slice(1).toLowerCase();
    });
};